module.exports = __webpack_public_path__ + "img/icon-sv5.af60f6b5.png";